// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_RkkJ0","subNav":"index_subNav_OZtUX","main":"index_main_76ktV","footerWrap":"index_footerWrap_f-jJq"};